import React, { useEffect, useState } from "react";
import { Badge, Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  getItemCategoryActiveList,
  getProductActiveListByCategoryID,
  GetProductWithQtyRate_ByCategoryIDApi,
} from "../MeldiDhamCRUD";
import ElementPage from "../../Elements";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
// import { addItem } from "../../../store/cartSlice";
import { toast } from "react-toastify";
import CartDrawer from "../product/CartDrawer";
import { itemQtyRateMapActiveList_Dropdown } from "../CustomerCRUD";
import { FaSpinner } from "react-icons/fa";
import {
  addItem,
  selectCartItems,
  selectCartTotal,
  increaseQty,
  decreaseQty,
  removeItem,
  clearCart,
  updateQtyFromDropdown,
} from "../../../store/cartSlice";

const ProductCategoryPage = () => {
  const format = (v) => (Number(v) || 0).toLocaleString();
  const [showCart, setShowCart] = useState(false);
  const [products, setProducts] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [qtyRateList, setQtyRateList] = useState([]);
  const items = useSelector(selectCartItems);
  const total = useSelector(selectCartTotal);

  const pathUrl = process.env.REACT_APP_API_URL;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true);
    getCategoriesData();
  }, []);

  useEffect(() => {
    if (items.length > 0) {
      const updated = {};

      items.forEach((item) => {
        if (item.isFixedQty) {
          updated[item.id] = item.qty;
        }
      });

      setSelectedQty(updated);
    }
  }, [items]);

  // useEffect(() => {
  //   if (activeCategory) {
  //     getProductsData(activeCategory);
  //   }
  // }, [activeCategory]);

  const getCategoriesData = async () => {
    try {
      const res = await getItemCategoryActiveList();
      if (res.data.isSuccess) {
        setCategoryData(res.data.responseObject);
        if (res.data.responseObject.length > 0) {
          setActiveCategory(res.data.responseObject[0].productCategoryID);
          getProductsData(res.data.responseObject[0].productCategoryID);
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const getProductsData = async (categoryId) => {
    try {
      const res = await GetProductWithQtyRate_ByCategoryIDApi(categoryId);
      if (res.data.isSuccess) {
        setProducts(res.data.responseObject);
      }
    } finally {
      setLoading(false);
    }
  };

  const getLocalized = (item, field) => {
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    return item[`${field}_EN`] || item[field];
  };

  // const handleAddToCart = (prod) => {
  //   getItemQtyRateMapActiveListData(prod.productID);
  //   dispatch(
  //     addItem({
  //       id: prod.productID,
  //       prodCatgryID: prod.productCategoryID,
  //       name: getLocalized(prod, "productName"),
  //       categoryName: getLocalized(prod, "productCategoryName"),
  //       price: Number(prod.price) || 0,
  //       image: prod.photoPath,
  //       qty: 1,
  //     }),
  //   );
  //   toast.success(`${getLocalized(prod, "productName")} added to cart`);
  //   setShowCart(true);
  // };

  // const handleAddToCart = async (prod) => {
  //   let qtyRateListData = [];
  //   try {
  //     const res = await itemQtyRateMapActiveList_Dropdown(prod.productID);
  //     if (res?.data?.isSuccess === true) {
  //       qtyRateListData = res.data.responseObject || [];
  //     }
  //   } catch (error) {
  //     console.error("Qty Rate API error:", error);
  //   }

  //   const isFixed = prod.isFixedQty === true;

  //   // ✅ Set correct default qty + price
  //   const defaultQty =
  //     isFixed && qtyRateListData.length > 0 ? qtyRateListData[0].qty : 1;

  //   const defaultPrice =
  //     isFixed && qtyRateListData.length > 0
  //       ? qtyRateListData[0].finalAmount
  //       : Number(prod.price) || 0;
  //   const displayPrice =
  //     isFixed && qtyRateListData.length > 0
  //       ? qtyRateListData[0].price
  //       : Number(prod.price) || 0;
  //   const courierCharge =
  //     isFixed && qtyRateListData.length > 0
  //       ? qtyRateListData[0].courierCharges
  //       : 0;
  //   dispatch(
  //     addItem({
  //       id: prod.productID,
  //       prodCatgryID: prod.productCategoryID,
  //       name: getLocalized(prod, "productName"),
  //       categoryName: getLocalized(prod, "productCategoryName"),
  //       image: prod.photoPath,

  //       isFixedQty: isFixed,
  //       qtyRateList: qtyRateListData,
  //       qty: defaultQty,
  //       price: defaultPrice,
  //       displayPrice: displayPrice,
  //       courierCharges: courierCharge,
  //     }),
  //   );

  //   toast.success(`${getLocalized(prod, "productName")} added to cart`);
  //   setShowCart(true);
  // };
  const handleAddToCart = (prod) => {
    const cartItem = items.find((i) => i.id === prod.productID);

    const isFixed = prod.isFixedQty === true;

    // 🔥 NON FIXED PRODUCT
    if (!isFixed) {
      const qty = cartItem?.qty || 1;

      dispatch(
        addItem({
          id: prod.productID,
          prodCatgryID: prod.productCategoryID,
          name: getLocalized(prod, "productName"),
          categoryName: getLocalized(prod, "productCategoryName"),
          image: prod.photoPath,
          isFixedQty: false,
          qty,
          price: Number(prod.price),
          finalAmount: qty * Number(prod.price),
        }),
      );

      setShowCart(true);
      return;
    }

    // 🔥 FIXED PRODUCT (your existing logic)
    const qtyRateListData = prod.qtyRateList || [];

    const qty = selectedQty[prod.productID] || qtyRateListData[0]?.qty;

    const selected = qtyRateListData.find((q) => q.qty === qty);

    dispatch(
      addItem({
        id: prod.productID,
        prodCatgryID: prod.productCategoryID,
        name: getLocalized(prod, "productName"),
        categoryName: getLocalized(prod, "productCategoryName"),
        image: prod.photoPath,
        isFixedQty: true,
        qtyRateList: qtyRateListData,
        qty,
        price: selected?.price,
        finalAmount: selected?.finalAmount,
        courierCharges: selected?.courierCharges,
      }),
    );

    setShowCart(true);
  };

  function closemodalclass() {
    // Sync selectedQty from Redux before closing
    const updated = {};

    items.forEach((item) => {
      if (item.isFixedQty) {
        updated[item.id] = item.qty;
      }
    });

    setSelectedQty(updated);

    setShowCart(false);
  }

  const [selectedQty, setSelectedQty] = useState({});

  return (
    <>
      <Container className="py-0">
        {/* 🔸 CATEGORY PILLS */}
        <div className="d-flex gap-0 overflow-auto pb-3">
          <span className="text-[#ff4f00]">{t("small")}:</span>
          {categoryData.map((cat) => {
            const isActive = activeCategory === cat.productCategoryID;
            return (
              <div
                key={cat.productCategoryID}
                className={`px-1 fw-semibold text-nowrap`}
                style={{
                  // cursor: "pointer",
                  // background: isActive ? "#FF4F00" : "#f8f9fa",
                  color: isActive ? "#FF4F00" : "#333",
                  // boxShadow: isActive
                  //   ? "0 4px 12px rgba(255,79,0,0.4)"
                  //   : "0 2px 6px rgba(0,0,0,0.1)",
                  // transition: "all 0.2s ease",
                }}
              >
                <Badge
                  onClick={() => getProductsData(cat.productCategoryID)}
                  className="cursor-pointer bg-danger"
                >
                  {" "}
                  {getLocalized(cat, "productCategoryName")}
                </Badge>
              </div>
            );
          })}
        </div>

        {/* 🔸 PRODUCT LIST */}
        {loading ? (
          <div
            className="col-12 d-flex flex-column justify-content-center align-items-center"
            style={{ minHeight: "60vh" }} // Or use 'minHeight: "60vh"' for full center
          >
            <FaSpinner className="animate-spin text-3xl text-primary mb-2" />
          </div>
        ) : products.length > 0 ? (
          <Row className="g-4">
            {products.map((prod) => (
              <Col key={prod.productID} xs={12} sm={6} md={4} lg={4}>
                <Card
                  className="h-100 border-0"
                  style={{
                    borderRadius: "16px",
                    boxShadow: "0 8px 18px rgba(0,0,0,0.12)",
                    transition: "transform 0.25s ease",
                  }}
                >
                  {/* IMAGE – FULL VISIBLE */}
                  <div
                    className="d-flex align-items-center justify-content-center bg-light pb-1"
                    style={{
                      height: "180px",
                      borderTopLeftRadius: "16px",
                      borderTopRightRadius: "16px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={pathUrl + prod.photoPath}
                      alt={getLocalized(prod, "productName")}
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  <Card.Body className="d-flex flex-column">
                    <p className="fw-semibold mb-1 fs-5">
                      {getLocalized(prod, "productName")}
                    </p>

                    {(() => {
                      const cartItem = items.find(
                        (i) => i.id === prod.productID,
                      );
                      const isFixed = prod.isFixedQty === true;

                      const qty = cartItem ? cartItem.qty : 0;

                      return (
                        <div className="mt-2">
                          {/* 🔹 FIXED PRODUCT → DROPDOWN */}
                          {isFixed ? (
                            <div className="d-flex align-items-center">
                              <label className="me-2 fw-semibold">Qty:</label>

                              <select
                                className="form-select form-select-sm"
                                style={{ width: "120px" }}
                                value={
                                  selectedQty[prod.productID] ||
                                  prod.qtyRateList?.[0]?.qty
                                }
                                onChange={(e) => {
                                  const newQty = Number(e.target.value);

                                  setSelectedQty({
                                    ...selectedQty,
                                    [prod.productID]: newQty,
                                  });

                                  // If already in cart → update redux also
                                  if (cartItem) {
                                    const selected = prod.qtyRateList.find(
                                      (q) => q.qty === newQty,
                                    );

                                    // if (selected) {
                                    //   dispatch(
                                    //     updateQtyFromDropdown({
                                    //       id: prod.productID,
                                    //       qty: selected.qty,
                                    //       price: selected.price,
                                    //       finalAmount: selected.finalAmount,
                                    //       courierCharges:
                                    //         selected.courierCharges,
                                    //     }),
                                    //   );
                                    // }
                                  }
                                }}
                              >
                                {prod.qtyRateList?.map((q) => (
                                  <option
                                    key={q.productQtyRateMapID}
                                    value={q.qty}
                                  >
                                    {q.qty}
                                  </option>
                                ))}
                              </select>
                            </div>
                          ) : /* 🔹 NON-FIXED PRODUCT → + / – */
                          // <div className="d-flex align-items-center">
                          //   <button
                          //     className="btn btn-sm btn-outline-secondary"
                          //     disabled={qty <= 1}
                          //     onClick={() =>
                          //       dispatch(decreaseQty(prod.productID))
                          //     }
                          //   >
                          //     –
                          //   </button>

                          //   <span className="mx-3 fw-bold">
                          //     {qty > 0 ? qty : 1}
                          //   </span>

                          //   <button
                          //     className="btn btn-sm btn-outline-secondary"
                          //     onClick={() => {
                          //       // if (!cartItem) {
                          //       //   dispatch(
                          //       //     addItem({
                          //       //       id: prod.productID,
                          //       //       prodCatgryID: prod.productCategoryID,
                          //       //       name: getLocalized(prod, "productName"),
                          //       //       categoryName: getLocalized(
                          //       //         prod,
                          //       //         "productCategoryName",
                          //       //       ),
                          //       //       image: prod.photoPath,
                          //       //       isFixedQty: false,
                          //       //       qty: 1,
                          //       //       price: Number(prod.price),
                          //       //       finalAmount: Number(prod.price),
                          //       //     }),
                          //       //   );
                          //       // } else {
                          //       dispatch(increaseQty(prod.productID));
                          //       // }
                          //     }}
                          //   >
                          //     +
                          //   </button>
                          // </div>
                          null}

                          {/* 🔹 PRICE SECTION */}
                          <div className="mt-2 fw-bold">
                            <span>Price: </span> ₹{" "}
                            {format(
                              isFixed
                                ? (() => {
                                    const selectedQtyValue =
                                      selectedQty[prod.productID] ||
                                      prod.qtyRateList?.[0]?.qty;

                                    const selected = prod.qtyRateList?.find(
                                      (q) => q.qty === selectedQtyValue,
                                    );

                                    return selected
                                      ? selected.finalAmount
                                      : prod.price;
                                  })()
                                : prod.price
                                  ? prod.price
                                  : qty * Number(prod.price),
                            )}
                          </div>

                          {isFixed && (
                            <p className="text-success small mb-1">
                              Price shown includes taxes and delivery charges.
                            </p>
                          )}
                        </div>
                      );
                    })()}

                    {/* 
                    {items.map((item) => (
                      <>
                        <span className="fw-bold text-[#ff4f00] mb-3">
                          {item.isFixedQty == true ? (
                            // 🔹 FIXED QTY → DROPDOWN
                            <span className="d-flex">
                              <label htmlFor="Qty" className="px-2">
                                Qty:
                              </label>
                              <select
                                className="form-select form-select-sm"
                                style={{ width: "40%" }}
                                value={item.qty}
                                onChange={(e) => {
                                  const selected = item.qtyRateList.find(
                                    (q) => q.qty === Number(e.target.value),
                                  );
                                  if (!selected) return;

                                  dispatch(
                                    updateQtyFromDropdown({
                                      id: item.id,
                                      qty: selected.qty,
                                      price: selected.finalAmount,
                                      displayPrice: selected.price,
                                      courierCharges: selected.courierCharges,
                                    }),
                                  );
                                }}
                              >
                                {item.qtyRateList.map((q) => (
                                  <option
                                    key={q.productQtyRateMapID}
                                    value={q.qty}
                                  >
                                    {q.qty}
                                  </option>
                                ))}
                              </select>
                              {/* <div className="text-success">
                                <span className="ms-2">Price:</span> ₹{" "}
                                {format(item.displayPrice)}
                              </div> *
                            </span>
                          ) : (
                            <span> ₹ {prod.price}</span>
                          )}
                        </span>{" "}
                        <div className="text-start">
                          {item.isFixedQty ? (
                            <>
                              <div className="fw-bold">
                                {" "}
                                <span>Price: </span>₹ {format(item.price)}
                              </div>
                              <p
                                className="text-success fs-7 mb-2"
                                style={{ lineHeight: "1.1" }}
                              >
                                Price shown includes taxes and delivery charges.
                              </p>
                            </>
                          ) : null}
                          {/* <button
                            className="btn btn-sm btn-link text-danger"
                            onClick={() => dispatch(removeItem(item.id))}
                          >
                            Remove
                          </button>{" "} *
                        </div>
                      </>
                    ))} */}

                    <div className="mt-auto d-flex gap-2">
                      <Button
                        size="sm"
                        className="w-100"
                        style={{ backgroundColor: "#FF4F00", border: "none" }}
                        onClick={() => handleAddToCart(prod)}
                      >
                        <i className="bi bi-cart-plus-fill me-1"></i>
                        Add To Cart
                      </Button>

                      <Link
                        to={`/product/${prod.productID}`}
                        className="btn btn-sm btn-outline-danger w-100"
                      >
                        <i className="bi bi-eye-fill me-1" />
                        View
                      </Link>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        ) : // <div className="text-center py-5">
        //   <p className="text-muted">{t("no_data")}</p>
        //   <img src="/assets/logo/15-dark.png" width={60} />
        // </div>
        null}
      </Container>

      {/* <ElementPage /> */}

      <CartDrawer show={showCart} onHide={closemodalclass} />
    </>
  );
};

export default ProductCategoryPage;
